import React from 'react';
import Icon from 'components/Icon';
import { getContext } from 'common';
import { AppBannerContext } from 'components/AppBanner';
import NokiaLogoSvg from '@nokia-csf-uxr/ccfk-assets/logos/Nokia_logo_blue.svg';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import Styled from './styles';

export interface AppBannerLogoProps {
  /** Defaults to the Nokia logo. Pass in an <Icon /> to pass your own logo through. */
  children?: React.ReactNode;
}

/** AppBannerLogo component, defaults to Nokia logo, you can pass in your own logo as well. */
const AppBannerLogo: React.FC<AppBannerLogoProps> = React.forwardRef<HTMLElement, AppBannerLogoProps>((props: AppBannerLogoProps, ref) =>
  getContext(({ RTL }: { RTL: boolean }) => {
    const {
      children,
      ...otherProps
    } = props;
    const { expanded }: { expanded?: boolean } = React.useContext(AppBannerContext); // if drawer is expanded (in mobile view)
    return (
      <Styled.Logo $rtl={RTL} ref={ref} $expanded={expanded} {...otherProps}>
        {children || <Icon src={NokiaLogoSvg} size="100%" color={Tokens.COLORS.WHITE} RTL={false} />}
      </Styled.Logo>
    );
  }));

AppBannerLogo.defaultProps = {
  children: undefined
};

AppBannerLogo.displayName = 'AppBannerLogo';
export default AppBannerLogo;
